module.exports = {
    BACK_DOMAIN: process.env.REACT_APP_BACK_API_URL || 'https://allocation.peppermint.company/api'
  }
  